import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const isBenignResizeObserverError = (message = "") =>
  message === "ResizeObserver loop completed with undelivered notifications." ||
  message === "ResizeObserver loop limit exceeded";

window.addEventListener("error", (event) => {
  if (isBenignResizeObserverError(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
